<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<m-search-item label="规则名称">
					<c-input name="rule_name" maxlength="100"></c-input>
				</m-search-item>
				<m-search-item label="规则类型">
					<c-select name="rule_type" :options="dispatchRuleTypeDic" clearable></c-select>
				</m-search-item>
				<m-search-item label="是否启用">
					<c-select name="is_enable" :options="disableEnableDic" clearable></c-select>
				</m-search-item>
			</m-search>
            <m-operate>
                <c-button color="main" v-if="auth('b_dispatch_rule_edit')" prepend-icon="tf-config" @click="soreRulesConfig()">排序规则配置</c-button>
            </m-operate>


			<c-table ref="list" height="grow" :paging="true">
<!--				<c-table-column-->
<!--					label="规则编码"-->
<!--					name="rule_code"-->
<!--					width="150"-->
<!--				></c-table-column>-->

				<c-table-column
					label="规则名称"
					name="rule_name"
					width="200"
				></c-table-column>

				<c-table-column
					label="规则类型"
					name="rule_type"
					width="100"
				>
					<template #default="{data}">
                        <c-state  dict="dispatchRuleTypeDic" tag :value="data.rule_type"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="执行顺序"
					name="rule_order"
					width="90"
				></c-table-column>

                <c-table-column
					label="规则权重"
					name="weight"
					width="120"
				>
                    <template #default="{data}">
                        {{data.weight?(data.weight*100+'%'):'-'}}
                    </template>
                </c-table-column>

				<c-table-column
					label="是否启用"
					name="is_enable"
					width="90"
				>
					<template #default="{data}">
                        <c-state dict="disableEnableDic" tag :value="data.is_enable"></c-state>
					</template>
				</c-table-column>

				<c-table-column
					label="创建人"
					name="create_user_realname"
					width="110"
				></c-table-column>

				<c-table-column
					label="创建时间"
					name="create_date"
					width="140"
				></c-table-column>

				<c-table-column
					type="button"
					label="操作"
					width="220"
					button-limit="3"
				>
					<template #default="{data}">
                        <c-table-button v-if="auth('b_dispatch_rule_edit') && canEnable(data)" @click="stateHandle(data.is_enable, data)">{{data.is_enable==1 ? '禁用' : '启用'}}</c-table-button>
                        <c-table-button v-else icon="tf-trash" :disabled="true">{{data.is_enable==1 ? '禁用' : '启用'}}</c-table-button>
                        <c-table-button v-if="auth('b_dispatch_rule_view')" icon="tf-view" @click="globalDialog('dispatchRuleDetail', {props: {id: data.id}})">查看</c-table-button>
					</template>
				</c-table-column>
			</c-table>
            <c-dialog ref="sortRulesConfigDialog" title="排序规则配置" width="600px" @resolve="saveSortRulesConfig" >
                <c-form ref="distanceForm">
                    <c-tips style="color:blue">
                        请配置排序规则的启用状态和权重分配，所有启用规则的权重总和必须等于100%
                        <p v-if="sortRulesWeightSum != 100" style="color:red">
                            当前启用排序规则权重总和为：<b>{{sortRulesWeightSum}}%</b>
                        </p>
                    </c-tips>
                    <c-table ref="sortRulesConfig" :data="sortRules" auto-height="true" :paging="false" border>>
                        <c-table-column
                                label="规则名称"
                                name="rule_name"
                                width="200"
                        ></c-table-column>
                        <c-table-column
                                label="规则权重"
                                name="rule_code"
                                width="90"
                        >
                            <template #default="{data, index}">
                                <c-input v-model="sortRules[index].weightPercent" type="number" :precision="0" :range="[0,100]" step=1 :clear="false" append-text="%"></c-input>
                            </template>

                        </c-table-column>
                        <c-table-column
                                label="状态"
                                name="weight"
                                width="80"
                        >
                            <template #default="{data, index}">
                                <c-switch v-model="sortRules[index].is_enable" :state-value="[1, 2]"></c-switch>
                            </template>
                        </c-table-column>
                    </c-table>
                </c-form>
                <template #button>
                    <c-button size="form" color="main" @click="saveSortRulesConfig" :disabled="sortRulesWeightSum != 100">确定</c-button>
                    <c-button  size="form" color="grey" @click="closeSortRulesConfigDialog()">取消</c-button>
                </template>
            </c-dialog>
		</module>
	</page>
</template>

<script>
    import { mapState } from 'vuex';


	export default {
		components: {
		},

		data() {
			return {
                sortRules: []
            }
		},

        computed:{
            ...mapState(['dispatchRuleTypeDic','disableEnableDic']),
            sortRulesWeightSum() {
                if (this.sortRules.length === 0) return null;
                return this.sortRules.filter(rule => rule.is_enable==1).reduce((sum, rule) => sum + Number(rule.weightPercent || 0), 0);
            },
		},

		mounted() {
			this.searchHandle();
		},

		methods: {
			searchHandle(data){
				if (!data){
					data = {};
				}
				this.$refs.list.load({
					url: '/dispatch/rule/list',
					data,
					success: () => {
					}
				});
			},

            soreRulesConfig() {
                this.sortRules=[];
                this.request({
                    url: '/dispatch/rule/list',
                    data: {
                        pageIndex: 1,
                        pageSize: 9999,
                        rule_type: 2
                    },
                    success: (data, message) => {
                       this.sortRules=data;
                       this.$refs.sortRulesConfigDialog.open();
                    }
                })
			},

            /******派单规则启禁用*********/
            stateHandle(state, data) {
                var message = '';
                if (state == 2) {
                    message = '确认启用【'+data.rule_name+'】派单规则吗？';
                } else {
                    message = '确认禁用'+data.rule_name+'派单规则吗？';
                }
                this.$confirm({
                    message: message,  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: '/dispatch/rule/state',
                            data: {
                                id: data.id,
                                is_enable: state==1 ? 2 : 1
                            },
                            success: (data, message) => {
                                this.$message({
                                    message: message,  // 提示内容,
                                    type: 'success'
                                });
                                this.$refs.list.update()
                            }
                        })
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                })


            },
            /******派单规则能否启禁用判断*********/
            canEnable(data) {
                if (data.rule_code == 'OUTLET_FILTER' || data.rule_code == 'CORE_CIRCLE_FILTER') {
                    return false
                }
                if(data.rule_type==2){
                    return false
                }
                return true
            },
            saveSortRulesConfig(){
                this.request({
                    url: '/dispatch/rule/weightConfig',
                    data: {
                        sort_rules: this.sortRules.map(rule => {
                            return {
                                id: rule.id,
                                weight_percent: rule.weightPercent,
                                is_enable: rule.is_enable
                            }
                        })
                    },
                    success: (data, message) => {
                        this.$message({
                            message: message,  // 提示内容,
                            type: 'success'
                        });
                        this.$refs.sortRulesConfigDialog.close();
                        this.$refs.list.update()
                    }
                })
            },
            closeSortRulesConfigDialog(){
                this.$refs.sortRulesConfigDialog.close();
            }
		}
	}
</script>

<style lang="stylus" scoped>
</style>
